"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelResultSubspace = void 0;
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable jsx-a11y/label-has-associated-control */
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var Utils_1 = require("../util/Utils");
var modelAccuracyDescription = (React.createElement("label", null,
    "How accurately does this model predict ",
    React.createElement("strong", null, "Field A"),
    " in your dataset?"));
var ModelResultSubspace = function (props) {
    var type = props.modelType;
    var value = props.modelResult;
    // this is a workaround to get the r2/auc value from the response since the response is not well formed JSON file and parser won't work on it
    var idx1 = type === Utils_1.ModelType.Regression ? value.indexOf('r2') : value.indexOf('auc');
    var idx2 = type === Utils_1.ModelType.Regression ? value.indexOf('mse') : value.indexOf('gini');
    var result = type === Utils_1.ModelType.Regression ? value.substring(idx1 + 4, idx2 - 2) : value.substring(idx1 + 5, idx2 - 3);
    var metricName = type === Utils_1.ModelType.Regression ? (React.createElement("label", null,
        "R",
        React.createElement("sup", null, "2"))) : (React.createElement("label", null, " AUC "));
    var renderModelAccuracy = function () {
        return (React.createElement(prediction_model_results_viz_1.ProgressBarComponent, { metricName: metricName, value: Number(result), tooltipContent: Localize_1.Messages.aucTooltip(), minLabel: Localize_1.Messages.minLabel(), maxLabel: Localize_1.Messages.maxLabel(), title: Localize_1.Messages.modelAccuracytitle(), description: modelAccuracyDescription, buttonLabel: Localize_1.Messages.evaluationButtonLabel(), onButtonClick: function () { } }));
    };
    return React.createElement("div", null, renderModelAccuracy());
};
exports.ModelResultSubspace = ModelResultSubspace;
//# sourceMappingURL=ModelResultSubspace.js.map